export default "__VITE_ASSET__BUiN$6gv__"